var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopic2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 92.17 112.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-61);}.cls-2{fill:url(#linear-gradient-15);}.cls-3{fill:url(#linear-gradient-13);}.cls-4{fill:url(#linear-gradient-28);}.cls-5{fill:url(#linear-gradient-53);}.cls-6{fill:url(#linear-gradient-42);}.cls-7{fill:url(#linear-gradient-46);}.cls-8{fill:url(#linear-gradient-60);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-56);}.cls-11{fill:url(#linear-gradient-43);}.cls-12{fill:url(#linear-gradient-25);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-12);}.cls-15{fill:url(#linear-gradient-40);}.cls-16{fill:url(#linear-gradient-27);}.cls-17{fill:#161617;}.cls-18{fill:url(#linear-gradient-37);}.cls-19{fill:url(#linear-gradient-55);}.cls-20{fill:url(#linear-gradient-39);}.cls-21{fill:url(#linear-gradient-52);}.cls-22{fill:#090909;}.cls-23{fill:#cdcc9a;}.cls-24{fill:url(#linear-gradient-58);}.cls-25{fill:url(#linear-gradient-47);}.cls-26{fill:url(#linear-gradient-26);}.cls-27{fill:url(#linear-gradient-4);}.cls-28{fill:url(#linear-gradient-35);}.cls-29{fill:url(#linear-gradient-30);}.cls-30{fill:url(#radial-gradient);}.cls-31{fill:url(#radial-gradient-3);}.cls-32{fill:url(#linear-gradient-44);}.cls-33{fill:url(#linear-gradient-49);}.cls-34{fill:url(#linear-gradient-3);}.cls-35{fill:url(#linear-gradient-34);}.cls-36{fill:url(#linear-gradient-5);}.cls-37{fill:url(#linear-gradient-38);}.cls-38{fill:url(#linear-gradient-22);}.cls-39{fill:url(#linear-gradient-24);}.cls-40{fill:url(#linear-gradient-54);}.cls-41{fill:url(#linear-gradient-33);}.cls-42{fill:url(#linear-gradient-51);}.cls-43{fill:url(#linear-gradient-8);}.cls-44{fill:url(#linear-gradient-57);}.cls-45{fill:#336634;}.cls-46{fill:url(#radial-gradient-2);}.cls-47{fill:url(#linear-gradient-14);}.cls-48{fill:url(#linear-gradient-62);}.cls-49{fill:url(#linear-gradient-29);}.cls-50{fill:url(#linear-gradient-20);}.cls-51{fill:url(#radial-gradient-4);}.cls-52{fill:url(#linear-gradient-17);}.cls-53{fill:url(#linear-gradient-50);}.cls-54{fill:url(#linear-gradient-7);}.cls-55{fill:url(#linear-gradient-9);}.cls-56{fill:url(#linear-gradient-59);}.cls-57{fill:url(#linear-gradient-11);}.cls-58{fill:url(#linear-gradient-19);}.cls-59{fill:url(#linear-gradient-6);}.cls-60{fill:url(#linear-gradient-36);}.cls-61{fill:url(#linear-gradient-21);}.cls-62{fill:url(#linear-gradient-45);}.cls-63{fill:url(#linear-gradient-48);}.cls-64{fill:url(#linear-gradient-32);}.cls-65{fill:url(#linear-gradient-41);}.cls-66{fill:url(#linear-gradient-16);}.cls-67{fill:url(#linear-gradient);}.cls-68{fill:url(#linear-gradient-23);}.cls-69{fill:url(#linear-gradient-31);}.cls-70{fill:url(#linear-gradient-18);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 45.76,
    cy: 77.14,
    fx: 45.76,
    fy: 77.14,
    r: 45.56,
    gradientTransform: "translate(0 125.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#336634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#699836"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 30.36,
    y1: 49.85,
    x2: 41.32,
    y2: 49.85,
    gradientTransform: "translate(-.8 127.03) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#699836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 29.57,
    y1: 53.11,
    x2: 39.93,
    y2: 53.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 29.25,
    y1: 55.87,
    x2: 38.15,
    y2: 55.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 29.45,
    y1: 57.98,
    x2: 36.34,
    y2: 57.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 29.78,
    y1: 59.87,
    x2: 34.56,
    y2: 59.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 30.21,
    y1: 61.65,
    x2: 32.72,
    y2: 61.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 27.91,
    y1: 64.94,
    x2: 32.28,
    y2: 64.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 26.11,
    y1: 67.03,
    x2: 32.37,
    y2: 67.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 24.3,
    y1: 69.6,
    x2: 31.98,
    y2: 69.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 22.58,
    y1: 72.66,
    x2: 30.99,
    y2: 72.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 21.18,
    y1: 75.92,
    x2: 29.59,
    y2: 75.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 20.18,
    y1: 78.98,
    x2: 27.86,
    y2: 78.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 19.73,
    y1: 81.63,
    x2: 26.09,
    y2: 81.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 19.72,
    y1: 83.66,
    x2: 24.25,
    y2: 83.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 19.94,
    y1: 85.51,
    x2: 22.27,
    y2: 85.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 17.6,
    y1: 88.71,
    x2: 22.38,
    y2: 88.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 15.82,
    y1: 90.6,
    x2: 22.71,
    y2: 90.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 14.01,
    y1: 92.73,
    x2: 22.98,
    y2: 92.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 12.23,
    y1: 95.46,
    x2: 22.59,
    y2: 95.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 10.84,
    y1: 98.72,
    x2: 21.8,
    y2: 98.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 40.45,
    y1: 51.62,
    x2: 42.04,
    y2: 51.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 39.09,
    y1: 54.8,
    x2: 40.68,
    y2: 54.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 28.5,
    y1: 54.37,
    x2: 30.1,
    y2: 54.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 37.31,
    y1: 57.33,
    x2: 38.91,
    y2: 57.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 35.46,
    y1: 59.32,
    x2: 37.05,
    y2: 59.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 28.65,
    y1: 56.87,
    x2: 30.24,
    y2: 56.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 33.81,
    y1: 60.84,
    x2: 35.4,
    y2: 60.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 28.99,
    y1: 59.07,
    x2: 30.58,
    y2: 59.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 31.76,
    y1: 62.08,
    x2: 33.35,
    y2: 62.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 29.35,
    y1: 61.21,
    x2: 30.94,
    y2: 61.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 29.89,
    y1: 63.43,
    x2: 31.48,
    y2: 63.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 31.35,
    y1: 66.1,
    x2: 32.94,
    y2: 66.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 31.52,
    y1: 68.72,
    x2: 33.11,
    y2: 68.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 31.1,
    y1: 71.72,
    x2: 32.69,
    y2: 71.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 30.15,
    y1: 74.96,
    x2: 31.74,
    y2: 74.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 28.83,
    y1: 78.26,
    x2: 30.42,
    y2: 78.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 19.44,
    y1: 76.94,
    x2: 21.03,
    y2: 76.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 27.04,
    y1: 80.96,
    x2: 28.63,
    y2: 80.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 19.1,
    y1: 80.17,
    x2: 20.69,
    y2: 80.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 25.31,
    y1: 83.13,
    x2: 26.9,
    y2: 83.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 23.31,
    y1: 84.78,
    x2: 24.9,
    y2: 84.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 18.99,
    y1: 82.6,
    x2: 20.58,
    y2: 82.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 19.07,
    y1: 84.98,
    x2: 20.66,
    y2: 84.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 21.54,
    y1: 86.21,
    x2: 23.13,
    y2: 86.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 21.55,
    y1: 89.49,
    x2: 23.14,
    y2: 89.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 21.86,
    y1: 91.86,
    x2: 23.45,
    y2: 91.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 15.18,
    y1: 89.43,
    x2: 16.77,
    y2: 89.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 13.26,
    y1: 91.24,
    x2: 14.86,
    y2: 91.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 22.15,
    y1: 94.21,
    x2: 23.74,
    y2: 94.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 21.95,
    y1: 97.08,
    x2: 23.54,
    y2: 97.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 11.49,
    y1: 93.78,
    x2: 13.08,
    y2: 93.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 21.39,
    y1: 100.43,
    x2: 22.98,
    y2: 100.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 9.69,
    y1: 96.83,
    x2: 11.28,
    y2: 96.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 16.92,
    y1: 87.8,
    x2: 18.51,
    y2: 87.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 19.66,
    y1: 87.11,
    x2: 21.25,
    y2: 87.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 20.55,
    y1: 73.57,
    x2: 22.14,
    y2: 73.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 21.81,
    y1: 70.4,
    x2: 23.4,
    y2: 70.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 23.59,
    y1: 67.48,
    x2: 25.18,
    y2: 67.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 27.13,
    y1: 63.75,
    x2: 28.72,
    y2: 63.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 25.37,
    y1: 65.42,
    x2: 26.96,
    y2: 65.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 28.84,
    y1: 51.38,
    x2: 30.43,
    y2: 51.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 29.7,
    y1: 48.19,
    x2: 31.29,
    y2: 48.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 75.74,
    cy: 91.31,
    fx: 75.74,
    fy: 91.31,
    r: 4.86,
    gradientTransform: "translate(-12.94 137.26) rotate(-7.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6eba4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45823b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 81.32,
    cy: 80.31,
    fx: 81.32,
    fy: 80.31,
    r: 4.86,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 72.5,
    cy: 81.86,
    fx: 72.5,
    fy: 81.86,
    r: 4.17,
    xlinkHref: "#radial-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2.22,109.83c-.23,0-.47,0-.73-.02-.26-.01-.52-.03-.78-.06-.26-.03-.5-.05-.72-.09v-8.58c.24-.05.49-.1.77-.14s.56-.07.85-.09c.29-.02.58-.03.86-.03.8,0,1.45.08,1.96.25.51.17.89.43,1.14.79s.37.81.37,1.37c0,.33-.06.62-.18.9s-.29.51-.52.7-.51.32-.85.39v-.07c.55.09.98.31,1.31.66s.49.84.49,1.47c0,.42-.08.79-.23,1.1-.15.31-.39.58-.71.79s-.73.38-1.24.48c-.51.11-1.11.16-1.8.16ZM2.69,108.46c.45,0,.81-.04,1.08-.13.27-.09.47-.23.59-.41.12-.18.18-.42.18-.72,0-.43-.13-.75-.4-.95-.26-.2-.68-.31-1.26-.31h-1.35v-1.42h1.17c.4,0,.72-.04.94-.13.23-.09.39-.22.49-.39.1-.17.15-.39.15-.65,0-.42-.12-.71-.35-.89-.24-.18-.64-.27-1.2-.27-.19,0-.37,0-.54.02-.16.01-.33.04-.5.06v6.14c.19.01.36.02.51.03.15,0,.31.01.47.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M7.79,102.27c-.37,0-.64-.09-.82-.26-.18-.17-.27-.41-.27-.71s.09-.55.27-.72c.18-.17.45-.26.82-.26s.65.09.82.26c.18.17.26.41.26.72s-.09.54-.26.71c-.18.17-.45.26-.82.26ZM6.92,109.73v-6.5h1.74v6.5h-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M12.15,109.85c-.57,0-1.06-.12-1.46-.35-.41-.23-.72-.6-.93-1.09-.21-.49-.32-1.13-.32-1.9s.11-1.43.32-1.93c.21-.5.52-.87.93-1.1.4-.24.89-.35,1.47-.35s1.05.12,1.46.36c.41.24.72.61.93,1.11.21.5.32,1.13.32,1.9s-.11,1.42-.32,1.91-.52.86-.93,1.09c-.4.23-.89.35-1.46.35ZM12.15,108.55c.2,0,.37-.05.51-.16.14-.11.25-.31.32-.6s.11-.72.11-1.27-.04-1.01-.11-1.31c-.08-.3-.18-.51-.32-.62-.14-.11-.31-.17-.5-.17s-.37.05-.51.16c-.14.11-.25.31-.32.61s-.11.73-.11,1.29.04.99.11,1.29.18.5.32.61c.14.11.31.16.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M15.65,109.73v-6.5h1.44l.13.69h.08c.2-.26.44-.46.71-.59.27-.13.58-.2.92-.2s.65.07.93.22.49.38.65.72c.16.33.24.78.24,1.34v4.33h-1.73v-4.2c0-.33-.06-.55-.2-.68s-.3-.18-.52-.18c-.11,0-.22.02-.33.05-.11.03-.22.09-.33.16s-.19.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M23.27,109.85c-.54,0-.98-.17-1.31-.5-.34-.33-.5-.79-.5-1.36,0-.62.19-1.1.56-1.45s.99-.55,1.84-.62l1.04-.09.24,1.01-1.08.09c-.3.02-.53.11-.68.25-.15.15-.23.35-.23.61s.07.46.2.58c.13.13.31.19.53.19.13,0,.27-.03.41-.09s.27-.17.39-.32v-2.53c0-.28-.04-.5-.12-.66-.08-.16-.21-.27-.4-.34s-.42-.1-.73-.1c-.22,0-.47.02-.74.06s-.53.1-.78.18v-1.39c.27-.08.58-.13.91-.17.33-.04.65-.06.94-.06.59,0,1.08.08,1.46.24.38.16.67.43.85.81.18.38.28.88.28,1.52v4.03h-1.41l-.13-.68h-.08c-.15.29-.36.49-.62.62-.26.12-.54.19-.85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M27.36,109.73v-6.5h1.44l.13.69h.08c.2-.26.44-.46.71-.59.27-.13.58-.2.92-.2s.65.07.93.22.49.38.65.72c.16.33.24.78.24,1.34v4.33h-1.73v-4.2c0-.33-.06-.55-.2-.68s-.3-.18-.52-.18c-.11,0-.22.02-.33.05-.11.03-.22.09-.33.16s-.19.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M35.92,109.85c-.57,0-1.06-.12-1.46-.35-.41-.23-.72-.6-.93-1.09-.21-.49-.32-1.13-.32-1.9s.11-1.43.32-1.93c.21-.5.52-.87.93-1.1.4-.24.89-.35,1.47-.35s1.05.12,1.46.36c.41.24.72.61.93,1.11.21.5.32,1.13.32,1.9s-.11,1.42-.32,1.91-.52.86-.93,1.09c-.4.23-.89.35-1.46.35ZM35.92,108.55c.2,0,.37-.05.51-.16.14-.11.25-.31.32-.6s.11-.72.11-1.27-.04-1.01-.11-1.31c-.08-.3-.18-.51-.32-.62-.14-.11-.31-.17-.5-.17s-.37.05-.51.16c-.14.11-.25.31-.32.61s-.11.73-.11,1.29.04.99.11,1.29.18.5.32.61c.14.11.31.16.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M38.68,104.59v-1.37h4.16v1.37h-4.16ZM41.83,109.84c-.7,0-1.24-.18-1.63-.55-.39-.37-.58-.98-.58-1.83v-4.23l.31-2.29h1.41v6.32c0,.42.07.7.21.86s.38.24.72.24c.09,0,.19,0,.28-.01s.2-.02.32-.04v1.42c-.14.04-.31.07-.49.09-.19.02-.37.04-.55.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M46.28,109.85c-.73,0-1.32-.12-1.78-.34-.46-.23-.8-.59-1.02-1.09-.22-.5-.33-1.15-.33-1.96,0-.74.1-1.35.31-1.85.21-.5.51-.87.9-1.11.39-.25.87-.37,1.42-.37s.98.12,1.34.37c.36.25.64.62.83,1.12.19.5.28,1.13.28,1.88v.51h-3.82v-1.06h2.45l-.25.11c0-.48-.03-.85-.1-1.11-.06-.26-.16-.43-.28-.53-.12-.1-.28-.15-.45-.15s-.34.05-.47.15c-.13.1-.23.27-.3.53-.07.26-.1.63-.1,1.11v.76c0,.42.05.74.15.98.1.24.26.41.49.51.23.1.54.15.93.15.23,0,.46-.02.7-.06s.48-.09.74-.16v1.39c-.3.08-.58.13-.84.17-.26.04-.53.05-.81.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M51.58,109.85c-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.6-.98-1.09-.22-.5-.34-1.14-.34-1.93s.13-1.45.38-1.95c.25-.49.61-.85,1.07-1.08s1.01-.34,1.65-.34c.2,0,.4,0,.59.03.19.02.38.05.56.09v1.42c-.14-.03-.28-.05-.43-.07s-.28-.02-.4-.02c-.37,0-.68.06-.92.18-.24.12-.41.31-.53.59s-.17.64-.17,1.11c0,.5.05.89.16,1.17s.27.48.48.6c.21.12.48.17.8.17.15,0,.31-.02.47-.05.16-.03.34-.08.53-.14v1.43c-.22.08-.45.13-.69.17-.24.04-.47.05-.7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M53.7,109.73v-9.6h1.73v3.79h.08c.17-.25.38-.45.64-.59s.56-.21.92-.21c.32,0,.61.07.87.22.26.14.47.38.63.72.16.33.24.78.24,1.35v4.31h-1.73v-4.17c0-.34-.06-.57-.2-.7s-.3-.19-.52-.19c-.1,0-.21.02-.33.05-.12.03-.23.08-.33.15s-.2.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M59.81,109.73v-6.5h1.44l.13.69h.08c.2-.26.44-.46.71-.59.27-.13.58-.2.92-.2s.65.07.93.22.49.38.65.72c.16.33.24.78.24,1.34v4.33h-1.73v-4.2c0-.33-.06-.55-.2-.68s-.3-.18-.52-.18c-.11,0-.22.02-.33.05-.11.03-.22.09-.33.16s-.19.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M68.37,109.85c-.57,0-1.06-.12-1.46-.35-.41-.23-.72-.6-.93-1.09-.21-.49-.32-1.13-.32-1.9s.11-1.43.32-1.93c.21-.5.52-.87.93-1.1.4-.24.89-.35,1.47-.35s1.05.12,1.46.36c.41.24.72.61.93,1.11.21.5.32,1.13.32,1.9s-.11,1.42-.32,1.91-.52.86-.93,1.09c-.4.23-.89.35-1.46.35ZM68.37,108.55c.2,0,.37-.05.51-.16.14-.11.25-.31.32-.6s.11-.72.11-1.27-.04-1.01-.11-1.31c-.08-.3-.18-.51-.32-.62-.14-.11-.31-.17-.5-.17s-.37.05-.51.16c-.14.11-.25.31-.32.61s-.11.73-.11,1.29.04.99.11,1.29.18.5.32.61c.14.11.31.16.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M71.91,109.73v-9.6h1.73v9.6h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M77.14,109.85c-.57,0-1.06-.12-1.46-.35-.41-.23-.72-.6-.93-1.09-.21-.49-.32-1.13-.32-1.9s.11-1.43.32-1.93c.21-.5.52-.87.93-1.1.4-.24.89-.35,1.47-.35s1.05.12,1.46.36c.41.24.72.61.93,1.11.21.5.32,1.13.32,1.9s-.11,1.42-.32,1.91-.52.86-.93,1.09c-.4.23-.89.35-1.46.35ZM77.14,108.55c.2,0,.37-.05.51-.16.14-.11.25-.31.32-.6s.11-.72.11-1.27-.04-1.01-.11-1.31c-.08-.3-.18-.51-.32-.62-.14-.11-.31-.17-.5-.17s-.37.05-.51.16c-.14.11-.25.31-.32.61s-.11.73-.11,1.29.04.99.11,1.29.18.5.32.61c.14.11.31.16.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M82.66,112.46c-.27,0-.56-.02-.87-.05-.31-.04-.61-.09-.89-.17v-1.39c.28.08.55.14.82.18.27.04.53.06.79.06.51,0,.9-.11,1.15-.34.26-.23.39-.63.39-1.21v-.48h-.08c-.13.23-.31.41-.54.55-.23.13-.51.2-.82.2-.36,0-.7-.11-1.03-.32-.33-.21-.59-.55-.8-1.02s-.31-1.09-.31-1.86c0-1.14.26-2.01.79-2.6.53-.59,1.35-.88,2.46-.88.23,0,.47.01.71.04.24.03.48.06.72.11.23.05.45.11.65.19v5.77c0,1.15-.26,1.97-.79,2.47-.52.5-1.3.75-2.34.75ZM83.33,108.35c.14,0,.27-.03.4-.08s.24-.13.31-.24v-3.52c-.07-.02-.15-.03-.23-.04-.09-.01-.17-.02-.25-.02-.42,0-.75.14-.98.42-.23.28-.35.8-.35,1.56,0,.52.04.92.13,1.19.09.28.21.47.38.57.16.1.36.15.59.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M88.07,109.73l-1.85-6.5h1.78l1.6,6.5h-1.53ZM87.88,112.34l.75-2.62.52-1.38,1.3-5.12h1.72l-2.6,9.12h-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M87.67,24.18h0c-.37-.63-.89-1.15-1.52-1.51L47.84.57c-.64-.37-1.36-.56-2.09-.57h0c-.73,0-1.44.2-2.08.57L5.37,22.67c-.64.37-1.18.9-1.55,1.53-.37.64-.57,1.36-.57,2.09v44.25c0,.74.2,1.47.57,2.12h.06c.37.62.89,1.13,1.52,1.48l38.3,22.12c.65.36,1.38.56,2.12.57h0c.72,0,1.42-.2,2.04-.55l38.3-22.12c1.29-.75,2.08-2.12,2.09-3.6V26.3c-.01-.75-.22-1.47-.59-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M45.8,93.61c-.72,0-1.43-.2-2.06-.55l-35.31-20.4c-.58-.33-1.07-.79-1.43-1.35h0l-.08-.11c-.36-.63-.55-1.34-.55-2.06V28.35c0-.72.19-1.42.55-2.04.37-.62.89-1.14,1.51-1.5L43.71,4.43c.62-.35,1.31-.54,2.03-.55h0c.71,0,1.42.19,2.04.55l35.37,20.38c.58.34,1.06.81,1.42,1.38h0l.07.09c.35.63.54,1.34.55,2.06v40.79c0,.71-.2,1.41-.55,2.03-.36.62-.87,1.13-1.48,1.49l-35.34,20.4c-.58.33-1.22.52-1.89.54h-.12ZM7.25,70.91l.08.08c.32.52.78.96,1.31,1.26l35.32,20.42c.54.3,1.14.46,1.76.48h.08c.62,0,1.23-.17,1.77-.48l35.31-20.38c.55-.33,1.01-.79,1.33-1.33.31-.55.48-1.17.48-1.8V28.35c0-.61-.16-1.22-.45-1.76l-.06-.08c-.32-.54-.77-.99-1.31-1.31L47.58,4.82c-.55-.32-1.18-.48-1.81-.49h0c-.63,0-1.25.18-1.8.49L8.65,25.21c-.56.32-1.02.78-1.35,1.33-.32.55-.49,1.17-.48,1.81v40.79c0,.61.15,1.22.44,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M73.41,32.61c-7.03-13.01-22.66-18.74-36.44-13.35h0l-.09.05c-1.06.43-2.1.91-3.11,1.45-14.23,7.67-19.55,25.42-11.88,39.65,7.67,14.23,25.42,19.55,39.65,11.88,14.23-7.67,19.55-25.42,11.88-39.65,0,0,0-.02-.01-.03ZM70.64,58.45c-.09-.33-.21-.65-.36-.96-.21-.44-.52-.83-.91-1.13-.41-.27-.87-.43-1.36-.48-.48-.07-.95-.13-1.43-.18s-.95-.1-1.41-.18c-.46-.05-.89-.25-1.21-.57-.32-.35-.59-.74-.86-1.12-.24-.37-.58-.68-.98-.88h0c.08-.1.06-.24-.04-.32h0c-.1-.08-.25-.06-.33.04-.08.1-.07.24.03.32.09.07.22.07.3-.01.36.26.66.61.87,1,.26.41.55.8.87,1.16.17.19.38.34.62.43.24.08.49.14.74.17.48.06.97.1,1.46.1.48,0,.95.04,1.42.13.47.07.9.27,1.27.57.62.55,1.08,1.26,1.33,2.05-2.32,4.44-5.88,8.1-10.25,10.54-.31-.11-.71-.27-1.16-.46.02-.3.06-.6.13-.89.12-.6.19-1.2.21-1.81.03-.31-.03-.63-.17-.91-.13-.27-.28-.53-.46-.77-.36-.47-.75-.92-1.16-1.34-.4-.43-.78-.88-1.11-1.36-.35-.47-.58-1.02-.65-1.6-.06-1.16.22-2.31.8-3.31h0c.12.04.25-.02.29-.14.05-.12-.02-.25-.13-.3-.12-.05-.25.02-.3.13-.04.12.01.25.13.29h0c-.35.49-.61,1.02-.79,1.59-.2.57-.26,1.18-.19,1.78.02.15.06.29.1.43.05.14.11.28.18.42.14.26.3.51.48.75.35.48.72.94,1.09,1.4s.76.9,1.1,1.37c.17.23.31.49.43.75.12.26.17.55.15.83-.03.57-.13,1.15-.22,1.74-.04.29-.07.58-.07.87-4.01-1.69-7.79-3.89-11.24-6.55.15-.11.3-.22.46-.32.37-.23.73-.48,1.06-.77.18-.15.32-.35.4-.58.07-.21.13-.43.16-.65.06-.44.06-.88.08-1.31,0-.43.05-.87.12-1.29.06-.42.24-.82.5-1.15.58-.63,1.33-1.09,2.16-1.32h0c-.44.06-.86.2-1.25.4-.41.2-.76.49-1.04.85-.23.34-.39.73-.45,1.13-.06.43-.11.87-.16,1.3s-.1.86-.17,1.28c-.03.42-.21.82-.5,1.13-.31.28-.66.53-1.01.8-.16.12-.31.25-.45.39-1.07-.84-2.15-1.76-3.23-2.75-3.36-3.14-6.06-6.91-7.94-11.1l.36.07c.43.1.86.17,1.3.21.24.02.49-.02.71-.13.2-.09.39-.21.57-.35.36-.27.65-.57.99-.85.31-.31.64-.59.99-.85.34-.26.75-.42,1.17-.46.77-.03,1.54.14,2.23.5,0,.04,0,.08.01.11h0c.06.11.2.16.32.11h0c.11-.05.16-.18.11-.29,0,0,0,0,0,0-.05-.12-.19-.17-.3-.11-.06.03-.11.08-.13.14-.3-.2-.63-.36-.98-.47-.42-.15-.87-.19-1.32-.14-.44.09-.84.29-1.19.57-.36.26-.66.53-1.03.81s-.66.54-1.02.79c-.32.26-.72.41-1.13.41-.42-.02-.85-.09-1.28-.15l-.45-.05c-1.61-3.75-2.48-7.78-2.55-11.86.22.14.43.3.62.47.35.33.72.62,1.12.89.21.14.46.23.71.24.24.02.48.01.72-.02.47-.07.94-.17,1.41-.29.46-.12.94-.2,1.41-.25.46-.06.93,0,1.36.19.84.44,1.53,1.1,2.01,1.92h0c-.2-.44-.46-.84-.78-1.2-.3-.39-.68-.7-1.12-.91-.47-.15-.97-.19-1.46-.1-.47.06-.94.12-1.42.21s-.94.12-1.42.18c-.45.08-.91,0-1.3-.21-.39-.25-.75-.55-1.13-.84-.22-.18-.46-.33-.72-.45-.05-3.29.3-6.57,1.04-9.77.17.2.32.41.46.62.29.47.62.91.97,1.32.19.22.43.39.7.48.26.1.54.17.82.2.55.08,1.1.1,1.64.13.55,0,1.09.06,1.63.15.56.08,1.09.32,1.52.69.8.72,1.36,1.65,1.64,2.69h0c-.09-.55-.27-1.08-.53-1.57-.24-.52-.6-.97-1.04-1.32-.11-.09-.23-.16-.36-.22-.13-.06-.26-.12-.39-.16-.27-.07-.54-.14-.81-.18-.55-.08-1.09-.14-1.64-.19s-1.09-.1-1.62-.2c-.26-.04-.51-.11-.75-.21-.24-.09-.46-.24-.63-.43-.36-.42-.69-.86-1-1.32-.17-.23-.36-.45-.56-.65.19-.85.41-1.71.66-2.58,4.33-2.22,9.21-3.17,14.06-2.73-.21.33-.38.68-.51,1.05-.16.47-.22.97-.16,1.46.09.5.31.97.64,1.37.29.4.6.78.91,1.16s.61.75.86,1.15c.14.2.25.4.35.62.09.21.14.44.13.66-.03.48-.11.95-.18,1.47-.09.43-.07.88.05,1.3-.08.03-.14.11-.14.2,0,.13.09.24.21.25.12.03.25-.04.28-.16,0-.03,0-.06,0-.09h0c.01-.13-.08-.24-.21-.25,0,0,0,0,0,0h-.06c-.06-.41-.03-.84.09-1.25.11-.48.19-.98.23-1.47.02-.26-.03-.53-.14-.76-.11-.24-.24-.46-.39-.67-.3-.39-.63-.76-.97-1.11-.34-.32-.66-.67-.95-1.05-.29-.38-.47-.84-.52-1.31-.04-.87.15-1.74.56-2.52,5.53.46,10.78,2.67,14.96,6.31-.34.07-.67.18-.98.33-.37.17-.7.44-.95.77-.23.34-.36.74-.4,1.15-.06.39-.1.79-.15,1.19s-.09.79-.16,1.18c-.04.38-.2.73-.46,1-.29.26-.6.49-.93.73-.31.2-.56.48-.72.81-.09-.03-.19,0-.25.07h0c-.08.1-.06.24.04.32h0c.1.07.25.06.33-.04h0c.08-.1.06-.25-.04-.33l-.05-.03c.21-.29.48-.53.79-.7.34-.21.67-.45.98-.71.32-.29.51-.68.55-1.11.05-.4.07-.8.08-1.2,0-.4.04-.79.11-1.18.05-.39.21-.75.46-1.05.5-.54,1.13-.95,1.83-1.17,4.09,3.65,6.91,8.5,8.06,13.86-.27-.17-.55-.31-.85-.41-.79-.32-1.69-.16-2.33.4-.32.24-.66.49-.96.74s-.66.51-.95.73c-.29.24-.66.38-1.04.39-.39-.02-.78-.09-1.19-.14-.32-.06-.66-.06-.98.01-.1-.09-.25-.08-.33.02-.05.05-.07.12-.06.18h0c.02.13.13.22.26.2,0,0,0,0,0,0,.13-.02.22-.13.2-.26,0,0,0,0,0,0,0-.03,0-.06-.01-.09.31-.01.62.02.91.1.39.09.79.16,1.19.19.43,0,.85-.15,1.17-.44.32-.26.62-.54.91-.83.29-.28.59-.54.92-.77.32-.24.69-.38,1.08-.42.72-.03,1.43.13,2.07.47,1.28,5.92.46,12.1-2.33,17.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M58.07,57.44h0c-.06-.11-.2-.16-.31-.11h0c-.11.07-.14.22-.06.33.06.09.17.13.27.09.11-.06.16-.2.11-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M58.83,57c-.07-.11-.21-.14-.32-.08h0c-.11.07-.14.21-.08.31.05.11.19.15.3.1,0,0,.01,0,.02,0,.11-.07.15-.21.08-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.24,56.45h0c-.11.07-.13.22-.06.33.07.11.21.14.32.07,0,0,0,0,0,0h0c.1-.09.11-.24.02-.33-.07-.08-.19-.1-.29-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.95,55.94h0c-.1.08-.12.22-.04.32h0c.08.1.23.12.33.05.1-.08.12-.22.04-.32,0,0,0,0,0,0-.08-.1-.23-.12-.33-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M60.62,55.39c-.1.08-.11.23-.03.32,0,0,0,0,0,0,.08.1.23.11.33.03h0c.08-.1.07-.24-.02-.33-.08-.07-.2-.08-.29-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M61.24,54.79h0c-.08.1-.08.24.02.33h0c.08.08.22.09.3,0,0,0,.01-.01.02-.02h0c.08-.11.05-.25-.06-.33-.08-.06-.19-.06-.28,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M62.7,53.44h0c-.09-.08-.23-.08-.31,0,0,0,0,0,0,0-.08.1-.06.25.04.32.1.08.25.06.32-.04h0c.07-.1.05-.25-.05-.32,0,0,0,0,0,0v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M62.85,52.77h0c-.07.11-.04.25.07.33h0c.1.07.25.05.32-.06,0,0,0,0,0-.01h0c.06-.11.02-.26-.09-.32-.1-.06-.23-.03-.3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M63.65,51.91h0c-.11-.06-.25-.02-.32.09h0c-.06.11-.02.25.09.31h0c.11.06.25.03.32-.08s.03-.25-.08-.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.05,51.17c-.11-.06-.25,0-.31.1,0,0,0,0,0,0-.05.12,0,.25.11.31h0c.11.06.25.01.31-.1,0,0,0,0,0,0h0c.06-.11.02-.25-.1-.31,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.39,50.34c-.12-.04-.25.01-.3.13h0c-.04.12.01.25.13.3h0c.12.05.25,0,.3-.12,0,0,0,0,0,0h0c.05-.12,0-.25-.12-.3,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.69,49.51c-.12-.04-.25.03-.29.14h0c-.03.12.03.25.14.29h0c.12.04.26-.02.3-.15.04-.12-.03-.25-.15-.29,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.93,48.66c-.12-.03-.25.04-.29.17h0c-.03.12.05.24.17.28h0c.12.03.25-.04.28-.16s-.04-.25-.16-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.11,47.79c-.13-.03-.25.05-.28.18h0c-.02.13.06.25.19.28h0c.13.02.25-.06.28-.19h0c.02-.12-.06-.24-.18-.27,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.24,46.92h0c-.13-.02-.24.07-.26.2h0c-.02.13.07.24.19.26.13.02.25-.07.27-.2.02-.13-.07-.24-.19-.26,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.31,46.04h0c-.12,0-.23.08-.24.2,0,0,0,0,0,.01h0c-.01.13.08.24.21.25,0,0,0,0,0,0h0c.12.01.23-.07.25-.2,0,0,0-.01,0-.02,0-.13-.09-.24-.22-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.33,45.16c-.13,0-.23.1-.23.23,0,0,0,0,0,0h0c0,.13.1.23.23.23,0,0,0,0,0,0h0c.13,0,.23-.09.24-.22,0,0,0,0,0,0h0c0-.13-.1-.23-.23-.23,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.18,43.4c-.13.01-.22.13-.2.25,0,0,0,0,0,0h0c.02.12.13.21.25.19h0c.13-.01.22-.13.2-.25,0,0,0,0,0,0-.01-.12-.12-.21-.25-.2,0,0-.01,0-.02,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.01,42.51h0c-.12.03-.2.15-.18.28h0c.02.12.14.2.27.18h0c.12-.02.2-.14.18-.26,0,0,0,0,0-.01h0c-.02-.13-.14-.21-.26-.19,0,0,0,0-.01,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.64,41.95h0c.03.12.16.2.28.17,0,0,0,0,0,0h0c.12-.04.2-.16.16-.29-.03-.12-.16-.2-.28-.17,0,0,0,0-.01,0-.12.04-.19.17-.16.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.4,41.1c.04.12.17.18.29.15h0c.12-.04.19-.17.15-.29,0,0,0,0,0,0h0c-.04-.12-.17-.18-.29-.14,0,0,0,0,0,0-.12.04-.18.17-.14.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.08,40.31c.05.12.18.17.3.12h0c.12-.05.18-.18.13-.3,0,0,0,0,0,0h0c-.05-.12-.18-.17-.3-.12,0,0,0,0,0,0-.12.05-.17.18-.12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M63.72,39.52h0c.06.11.19.16.31.11,0,0,0,0,0,0h0c.12-.06.17-.2.11-.31h0c-.06-.11-.2-.16-.31-.11-.11.06-.16.2-.11.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M63.32,38.75c.06.11.2.15.31.08h0c.11-.06.15-.2.09-.31,0,0,0,0,0,0h0c-.08-.1-.23-.12-.33-.04-.08.07-.11.18-.07.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M62.86,38.01h0c.07.1.21.13.32.06h0c.11-.06.14-.2.08-.3,0,0,0-.01,0-.02-.07-.11-.22-.14-.33-.07-.1.07-.13.21-.06.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M62.68,37.35h0c.1-.07.13-.22.05-.32,0,0,0,0,0,0h0c-.08-.1-.22-.12-.33-.05-.1.08-.12.23-.05.33.08.1.22.12.33.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M61.81,36.62h0c.09.09.23.1.32.02.09-.08.1-.23.02-.32-.08-.09-.23-.1-.32-.02-.09.08-.1.22-.02.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M60.58,35.4h0c.1.08.24.08.33-.02h0c.08-.09.08-.23,0-.31,0,0,0,0,0,0-.09-.09-.24-.08-.32.01,0,0,0,0,0,0-.08.1-.07.24.02.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.92,34.88h0c.1.08.24.07.32-.02h0c.09-.1.08-.25-.02-.33,0,0,0,0,0,0-.09-.09-.24-.08-.32.01,0,0,0,0,0,0h0c-.08.1-.07.24.02.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.21,34.33h0c.11.07.25.04.32-.06,0,0,0,0,0,0h0c.08-.1.07-.24-.03-.32-.1-.08-.24-.07-.32.03-.01.01-.02.03-.03.04h0c-.07.1-.05.25.06.32,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M58.48,33.87h0c.11.06.25.03.32-.08h0c.06-.11.03-.25-.08-.31s-.25-.03-.31.08c-.06.11-.03.25.08.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M57.72,33.46h0c.11.05.25,0,.31-.1h0c.06-.12.01-.26-.1-.32-.11-.06-.24-.02-.3.09,0,0,0,.01,0,.02-.05.11,0,.25.1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M56.92,33.09h0c.12.05.25,0,.3-.12h0c.05-.11,0-.24-.11-.3,0,0-.01,0-.02,0-.12-.05-.25,0-.31.12-.05.12,0,.25.12.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M56.12,32.78h0c.12.04.25-.02.29-.14,0,0,0,0,0,0h0c.04-.12-.02-.25-.14-.29,0,0,0,0,0,0h0c-.12-.04-.26.02-.3.15-.03.12.03.25.14.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M55.29,32.52c.12.03.25-.04.29-.16.04-.12-.03-.26-.16-.29h0c-.12-.03-.25.04-.28.16,0,0,0,0,0,0-.03.12.04.25.16.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M54.44,32.29c.13.02.25-.06.28-.18h0c.03-.12-.04-.24-.16-.27,0,0,0,0,0,0h0c-.13-.02-.24.06-.27.19-.02.12.05.23.16.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M52.73,32.07c.13.01.24-.08.25-.21h0c.01-.13-.08-.24-.21-.25h0c-.13,0-.24.09-.25.21h0c-.01.13.08.24.21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M51.86,32.03c.13,0,.23-.1.23-.23,0,0,0,0,0,0h0c0-.12-.08-.22-.2-.23,0,0-.02,0-.02,0h0c-.13.03-.21.16-.18.28.02.1.1.17.2.18h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M51,32.05h0c.13,0,.22-.11.22-.24h0c0-.13-.11-.23-.23-.22,0,0,0,0,0,0h0c-.13,0-.22.11-.22.24,0,0,0,0,0,0,0,.13.11.22.24.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M50.12,32.13c.13-.01.22-.13.2-.25,0,0,0,0,0,0h0c-.01-.13-.13-.22-.26-.21h0c-.13.02-.21.13-.19.26,0,0,0,0,0,0h0c.01.12.12.21.25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M49.27,32.26c.12-.03.2-.15.18-.28h0c-.02-.12-.13-.21-.25-.19,0,0,0,0,0,0h0c-.13.04-.2.17-.16.29.03.11.14.18.26.17h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M48.42,32.45h0c.12-.03.19-.16.16-.28-.03-.12-.15-.2-.27-.17,0,0,0,0,0,0h0c-.12.03-.2.15-.17.27,0,0,0,.01,0,.02.03.12.16.2.28.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M47.58,32.69h0c.12-.04.19-.17.15-.29,0,0,0,0,0,0h0c-.04-.12-.17-.2-.3-.16-.12.04-.18.16-.15.28,0,0,0,.01,0,.02.04.12.17.19.29.15,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M46.74,32.99h0c.12-.04.17-.17.13-.29,0,0,0,0,0,0h0c-.04-.12-.16-.18-.28-.14,0,0-.01,0-.02,0-.12.05-.18.19-.13.31.06.11.18.16.3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.87,33.79h0c.12.04.25-.02.29-.14,0,0,0,0,0,0h0c.03-.12-.03-.25-.14-.29-.12-.04-.25.02-.29.14,0,0,0,0,0,0h0c-.04.12.02.26.15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.58,34.62h0c.12.04.25-.03.29-.14h0c.04-.12-.02-.25-.14-.29,0,0,0,0,0,0-.12-.04-.26.03-.3.15h0c-.04.12.02.24.14.28,0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.35,35.48c.12.03.25-.04.29-.17h0c.03-.12-.04-.25-.17-.29h0c-.12-.03-.25.04-.28.16,0,0,0,0,0,0h0c-.03.12.04.25.17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.4,36.16h0c.03-.12-.04-.25-.17-.28-.13-.03-.25.05-.29.17-.03.12.05.25.17.28,0,0,0,0,0,0h0c.12.03.24-.04.27-.16,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.96,37.2h0c.12.03.25-.05.27-.18,0,0,0,0,0,0h0c.02-.13-.06-.25-.19-.28h0c-.12-.02-.24.06-.27.18,0,0,0,0,0,0-.02.12.06.24.18.27,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.85,38.07h0c.12.02.24-.07.26-.19h0c.02-.13-.07-.24-.19-.26-.13-.02-.25.07-.27.19-.01.13.08.24.21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.72,38.95h0c.13.02.24-.07.26-.2h0c.01-.13-.08-.24-.21-.25h0c-.13-.01-.25.08-.26.21h0c-.01.12.08.23.2.24,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.67,39.84h0c.13.02.24-.07.26-.2,0,0,0-.02,0-.03h0c0-.13-.09-.23-.22-.24,0,0,0,0,0,0-.12-.01-.23.07-.25.2,0,0,0,.01,0,.02,0,.12.08.23.21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.64,40.71h0c.13,0,.23-.1.23-.23,0,0,0,0,0,0h0c0-.13-.1-.23-.23-.23h0c-.13,0-.24.1-.25.24.01.13.12.22.24.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.68,41.6c.13,0,.23-.11.22-.23,0,0,0,0,0,0h0c0-.13-.11-.22-.24-.22h0c-.13,0-.23.11-.22.23,0,0,0,0,0,0h0c0,.12.1.22.23.22,0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.76,42.49h0c.13-.02.22-.13.21-.26h0c-.01-.13-.13-.22-.26-.21,0,0,0,0,0,0h0c-.13.01-.22.13-.2.25,0,0,0,0,0,0,.01.13.12.22.25.21,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.06,43.1c-.02-.12-.13-.21-.25-.19-.13.01-.22.13-.2.25,0,0,0,0,0,0h0c.03.12.14.21.27.19.12-.02.21-.14.19-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.05,44.23h0c.12-.03.2-.15.18-.28h0c-.02-.12-.14-.2-.26-.18,0,0,0,0-.01,0-.13.02-.21.14-.19.26,0,0,0,0,0,.01.02.12.14.2.26.18,0,0,0,0,.01,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.28,45.08c.12-.03.19-.16.16-.28-.04-.12-.16-.19-.29-.16-.12.03-.2.16-.17.28,0,0,0,0,0,.01h0c.03.12.16.19.28.16,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.69,45.63h0c-.04-.12-.17-.18-.29-.14,0,0,0,0,0,0h0c-.12.03-.19.16-.15.27,0,0,0,0,0,.01h0c.04.12.17.19.3.15,0,0,0,0,0,0h0c.12-.04.18-.17.14-.29,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M46.32,47.26h0c-.05-.12-.18-.17-.3-.12-.12.05-.17.19-.12.31,0,0,0,0,0,0,.05.11.18.17.29.12,0,0,0,0,0,0h0c.12-.05.17-.19.12-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M46.71,48.04h0c-.05-.11-.19-.15-.3-.1,0,0-.01,0-.02,0-.11.06-.16.2-.1.31.06.11.2.15.31.09,0,0,0,0,0,0h0c.11-.06.16-.2.1-.31,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M47.14,48.8h0c-.07-.11-.21-.15-.32-.08-.11.07-.15.21-.08.32.07.11.21.15.32.08h0c.11-.06.15-.2.08-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M47.61,49.54h0c-.07-.1-.21-.13-.32-.06h0c-.11.07-.14.21-.08.32,0,0,0,0,0,.01.08.1.22.13.33.06h0c.1-.06.14-.2.07-.31,0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M47.77,50.21c-.1.08-.13.22-.06.33h0c.07.1.22.13.32.05,0,0,0,0,0,0h0c.09-.09.09-.24,0-.33-.07-.07-.18-.09-.27-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M48.63,50.95h0c-.08-.1-.23-.11-.32-.03h0c-.1.08-.12.22-.05.32,0,0,0,0,0,.01.07.1.21.12.31.04,0,0,0,0,.01-.01h0c.1-.08.12-.22.04-.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M49.19,51.62h0c-.1-.08-.24-.07-.32.02-.1.08-.11.23-.03.33h0c.09.09.24.08.32-.01,0,0,0,0,0,0h0c.08-.09.08-.24-.02-.32h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M49.78,52.27h0c-.09-.09-.23-.1-.33,0-.09.09-.1.23,0,.33.09.09.24.08.32-.01,0,0,0,0,0,0h0c.08-.09.08-.24-.02-.32l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M50.07,52.89c-.09.09-.08.24.01.32,0,0,0,0,0,0h0c.09.09.24.08.32-.01,0,0,0,0,0,0,.09-.09.09-.24,0-.33s-.24-.09-.33,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M51.04,53.48c-.1-.08-.24-.07-.33.02-.07.11-.04.26.07.33.08.05.19.05.27-.01h0c.08-.1.07-.24-.02-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M51.38,54.09h0c-.08.09-.08.24.02.32h0c.09.09.24.08.32-.01,0,0,0,0,0,0h0c.08-.1.06-.24-.04-.32s-.24-.06-.32.04h0v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M52.4,54.59c-.1-.08-.24-.07-.33.02-.09.09-.08.24.01.32,0,0,0,0,0,0h0c.09.09.24.08.32-.01,0,0,0,0,0,0h0c.08-.1.08-.24-.02-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M52.77,55.18c-.07.1-.05.25.06.32s.25.05.32-.06h0c.07-.1.05-.25-.06-.32s-.25-.05-.32.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M53.49,55.69h0c-.07.11-.04.25.06.32,0,0,0,0,0,0,.1.07.24.05.31-.05,0,0,0,0,0-.01h0c.07-.1.05-.25-.06-.32,0,0,0,0,0,0-.1-.07-.25-.05-.32.06,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M54.24,56.16c-.07.11-.04.26.07.33,0,0,0,0,0,0h0c.11.07.25.03.32-.08,0,0,0,0,0,0h0c.07-.11.04-.25-.07-.32,0,0,0,0,0,0-.11-.06-.25-.03-.32.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M55.31,56.54c-.11-.06-.25-.02-.32.09-.06.11-.03.24.07.31h0c.11.05.25.01.31-.1h0c.06-.1.03-.23-.07-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M56.08,56.96c-.12-.06-.26-.01-.32.1h0c-.06.11-.01.25.1.31,0,0,0,0,0,0h0c.11.06.24.02.3-.08,0,0,0,0,0-.01h0c.06-.11.02-.26-.1-.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "57.22 58.02 57.22 58.02 57.23 58.02 57.23 58.02 57.21 58.02 57.22 58.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M58.07,57.44h0c-.06-.11-.2-.16-.31-.11h0c-.11.07-.14.22-.06.33.06.09.17.13.27.09.11-.06.16-.2.11-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M58.83,57c-.07-.11-.21-.14-.32-.08h0c-.11.07-.14.21-.08.31.05.11.19.15.3.1,0,0,.01,0,.02,0,.11-.07.15-.21.08-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.24,56.45h0c-.11.07-.13.22-.06.33.07.11.21.14.32.07,0,0,0,0,0,0h0c.1-.09.11-.24.02-.33-.07-.08-.19-.1-.29-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.95,55.94h0c-.1.08-.12.22-.04.32h0c.08.1.23.12.33.05.1-.08.12-.22.04-.32,0,0,0,0,0,0-.08-.1-.23-.12-.33-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M60.62,55.39c-.1.08-.11.23-.03.32,0,0,0,0,0,0,.08.1.23.11.33.03h0c.08-.1.07-.24-.02-.33-.08-.07-.2-.08-.29-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M61.24,54.79h0c-.08.1-.08.24.02.33h0c.08.08.22.09.3,0,0,0,.01-.01.02-.02h0c.08-.11.05-.25-.06-.33-.08-.06-.19-.06-.28,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M62.7,53.44h0c-.09-.08-.23-.08-.31,0,0,0,0,0,0,0-.08.1-.06.25.04.32.1.08.25.06.32-.04h0c.07-.1.05-.25-.05-.32,0,0,0,0,0,0v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M62.85,52.77h0c-.07.11-.04.25.07.33h0c.1.07.25.05.32-.06,0,0,0,0,0-.01h0c.06-.11.02-.26-.09-.32-.1-.06-.23-.03-.3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M63.65,51.91h0c-.11-.06-.25-.02-.32.09h0c-.06.11-.02.25.09.31h0c.11.06.25.03.32-.08s.03-.25-.08-.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.05,51.17c-.11-.06-.25,0-.31.1,0,0,0,0,0,0-.05.12,0,.25.11.31h0c.11.06.25.01.31-.1,0,0,0,0,0,0h0c.06-.11.02-.25-.1-.31,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.39,50.34c-.12-.04-.25.01-.3.13h0c-.04.12.01.25.13.3h0c.12.05.25,0,.3-.12,0,0,0,0,0,0h0c.05-.12,0-.25-.12-.3,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.69,49.51c-.12-.04-.25.03-.29.14h0c-.03.12.03.25.14.29h0c.12.04.26-.02.3-.15.04-.12-.03-.25-.15-.29,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.93,48.66c-.12-.03-.25.04-.29.17h0c-.03.12.05.24.17.28h0c.12.03.25-.04.28-.16s-.04-.25-.16-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.11,47.79c-.13-.03-.25.05-.28.18h0c-.02.13.06.25.19.28h0c.13.02.25-.06.28-.19h0c.02-.12-.06-.24-.18-.27,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.24,46.92h0c-.13-.02-.24.07-.26.2h0c-.02.13.07.24.19.26.13.02.25-.07.27-.2.02-.13-.07-.24-.19-.26,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.31,46.04h0c-.12,0-.23.08-.24.2,0,0,0,0,0,.01h0c-.01.13.08.24.21.25,0,0,0,0,0,0h0c.12.01.23-.07.25-.2,0,0,0-.01,0-.02,0-.13-.09-.24-.22-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.33,45.16c-.13,0-.23.1-.23.23,0,0,0,0,0,0h0c0,.13.1.23.23.23,0,0,0,0,0,0h0c.13,0,.23-.09.24-.22,0,0,0,0,0,0h0c0-.13-.1-.23-.23-.23,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.18,43.4c-.13.01-.22.13-.2.25,0,0,0,0,0,0h0c.02.12.13.21.25.19h0c.13-.01.22-.13.2-.25,0,0,0,0,0,0-.01-.12-.12-.21-.25-.2,0,0-.01,0-.02,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M65.01,42.51h0c-.12.03-.2.15-.18.28h0c.02.12.14.2.27.18h0c.12-.02.2-.14.18-.26,0,0,0,0,0-.01h0c-.02-.13-.14-.21-.26-.19,0,0,0,0-.01,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.64,41.95h0c.03.12.16.2.28.17,0,0,0,0,0,0h0c.12-.04.2-.16.16-.29-.03-.12-.16-.2-.28-.17,0,0,0,0-.01,0-.12.04-.19.17-.16.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.4,41.1c.04.12.17.18.29.15h0c.12-.04.19-.17.15-.29,0,0,0,0,0,0h0c-.04-.12-.17-.18-.29-.14,0,0,0,0,0,0-.12.04-.18.17-.14.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.08,40.31c.05.12.18.17.3.12h0c.12-.05.18-.18.13-.3,0,0,0,0,0,0h0c-.05-.12-.18-.17-.3-.12,0,0,0,0,0,0-.12.05-.17.18-.12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M63.72,39.52h0c.06.11.19.16.31.11,0,0,0,0,0,0h0c.12-.06.17-.2.11-.31h0c-.06-.11-.2-.16-.31-.11-.11.06-.16.2-.11.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M63.32,38.75c.06.11.2.15.31.08h0c.11-.06.15-.2.09-.31,0,0,0,0,0,0h0c-.08-.1-.23-.12-.33-.04-.08.07-.11.18-.07.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M62.86,38.01h0c.07.1.21.13.32.06h0c.11-.06.14-.2.08-.3,0,0,0-.01,0-.02-.07-.11-.22-.14-.33-.07-.1.07-.13.21-.06.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M62.68,37.35h0c.1-.07.13-.22.05-.32,0,0,0,0,0,0h0c-.08-.1-.22-.12-.33-.05-.1.08-.12.23-.05.33.08.1.22.12.33.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M61.81,36.62h0c.09.09.23.1.32.02.09-.08.1-.23.02-.32-.08-.09-.23-.1-.32-.02-.09.08-.1.22-.02.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M60.58,35.4h0c.1.08.24.08.33-.02h0c.08-.09.08-.23,0-.31,0,0,0,0,0,0-.09-.09-.24-.08-.32.01,0,0,0,0,0,0-.08.1-.07.24.02.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.92,34.88h0c.1.08.24.07.32-.02h0c.09-.1.08-.25-.02-.33,0,0,0,0,0,0-.09-.09-.24-.08-.32.01,0,0,0,0,0,0h0c-.08.1-.07.24.02.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.21,34.33h0c.11.07.25.04.32-.06,0,0,0,0,0,0h0c.08-.1.07-.24-.03-.32-.1-.08-.24-.07-.32.03-.01.01-.02.03-.03.04h0c-.07.1-.05.25.06.32,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M58.48,33.87h0c.11.06.25.03.32-.08h0c.06-.11.03-.25-.08-.31s-.25-.03-.31.08c-.06.11-.03.25.08.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M57.72,33.46h0c.11.05.25,0,.31-.1h0c.06-.12.01-.26-.1-.32-.11-.06-.24-.02-.3.09,0,0,0,.01,0,.02-.05.11,0,.25.1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M56.92,33.09h0c.12.05.25,0,.3-.12h0c.05-.11,0-.24-.11-.3,0,0-.01,0-.02,0-.12-.05-.25,0-.31.12-.05.12,0,.25.12.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M56.12,32.78h0c.12.04.25-.02.29-.14,0,0,0,0,0,0h0c.04-.12-.02-.25-.14-.29,0,0,0,0,0,0h0c-.12-.04-.26.02-.3.15-.03.12.03.25.14.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M55.29,32.52c.12.03.25-.04.29-.16.04-.12-.03-.26-.16-.29h0c-.12-.03-.25.04-.28.16,0,0,0,0,0,0-.03.12.04.25.16.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M54.44,32.29c.13.02.25-.06.28-.18h0c.03-.12-.04-.24-.16-.27,0,0,0,0,0,0h0c-.13-.02-.24.06-.27.19-.02.12.05.23.16.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M52.73,32.07c.13.01.24-.08.25-.21h0c.01-.13-.08-.24-.21-.25h0c-.13,0-.24.09-.25.21h0c-.01.13.08.24.21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M51.86,32.03c.13,0,.23-.1.23-.23,0,0,0,0,0,0h0c0-.12-.08-.22-.2-.23,0,0-.02,0-.02,0h0c-.13.03-.21.16-.18.28.02.1.1.17.2.18h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M51,32.05h0c.13,0,.22-.11.22-.24h0c0-.13-.11-.23-.23-.22,0,0,0,0,0,0h0c-.13,0-.22.11-.22.24,0,0,0,0,0,0,0,.13.11.22.24.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M50.12,32.13c.13-.01.22-.13.2-.25,0,0,0,0,0,0h0c-.01-.13-.13-.22-.26-.21h0c-.13.02-.21.13-.19.26,0,0,0,0,0,0h0c.01.12.12.21.25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M49.27,32.26c.12-.03.2-.15.18-.28h0c-.02-.12-.13-.21-.25-.19,0,0,0,0,0,0h0c-.13.04-.2.17-.16.29.03.11.14.18.26.17h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M48.42,32.45h0c.12-.03.19-.16.16-.28-.03-.12-.15-.2-.27-.17,0,0,0,0,0,0h0c-.12.03-.2.15-.17.27,0,0,0,.01,0,.02.03.12.16.2.28.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M47.58,32.69h0c.12-.04.19-.17.15-.29,0,0,0,0,0,0h0c-.04-.12-.17-.2-.3-.16-.12.04-.18.16-.15.28,0,0,0,.01,0,.02.04.12.17.19.29.15,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M46.74,32.99h0c.12-.04.17-.17.13-.29,0,0,0,0,0,0h0c-.04-.12-.16-.18-.28-.14,0,0-.01,0-.02,0-.12.05-.18.19-.13.31.06.11.18.16.3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.87,33.79h0c.12.04.25-.02.29-.14,0,0,0,0,0,0h0c.03-.12-.03-.25-.14-.29-.12-.04-.25.02-.29.14,0,0,0,0,0,0h0c-.04.12.02.26.15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.58,34.62h0c.12.04.25-.03.29-.14h0c.04-.12-.02-.25-.14-.29,0,0,0,0,0,0-.12-.04-.26.03-.3.15h0c-.04.12.02.24.14.28,0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.35,35.48c.12.03.25-.04.29-.17h0c.03-.12-.04-.25-.17-.29h0c-.12-.03-.25.04-.28.16,0,0,0,0,0,0h0c-.03.12.04.25.17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.4,36.16h0c.03-.12-.04-.25-.17-.28-.13-.03-.25.05-.29.17-.03.12.05.25.17.28,0,0,0,0,0,0h0c.12.03.24-.04.27-.16,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.96,37.2h0c.12.03.25-.05.27-.18,0,0,0,0,0,0h0c.02-.13-.06-.25-.19-.28h0c-.12-.02-.24.06-.27.18,0,0,0,0,0,0-.02.12.06.24.18.27,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.85,38.07h0c.12.02.24-.07.26-.19h0c.02-.13-.07-.24-.19-.26-.13-.02-.25.07-.27.19-.01.13.08.24.21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.72,38.95h0c.13.02.24-.07.26-.2h0c.01-.13-.08-.24-.21-.25h0c-.13-.01-.25.08-.26.21h0c-.01.12.08.23.2.24,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.67,39.84h0c.13.02.24-.07.26-.2,0,0,0-.02,0-.03h0c0-.13-.09-.23-.22-.24,0,0,0,0,0,0-.12-.01-.23.07-.25.2,0,0,0,.01,0,.02,0,.12.08.23.21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.64,40.71h0c.13,0,.23-.1.23-.23,0,0,0,0,0,0h0c0-.13-.1-.23-.23-.23h0c-.13,0-.24.1-.25.24.01.13.12.22.24.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.68,41.6c.13,0,.23-.11.22-.23,0,0,0,0,0,0h0c0-.13-.11-.22-.24-.22h0c-.13,0-.23.11-.22.23,0,0,0,0,0,0h0c0,.12.1.22.23.22,0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.76,42.49h0c.13-.02.22-.13.21-.26h0c-.01-.13-.13-.22-.26-.21,0,0,0,0,0,0h0c-.13.01-.22.13-.2.25,0,0,0,0,0,0,.01.13.12.22.25.21,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.06,43.1c-.02-.12-.13-.21-.25-.19-.13.01-.22.13-.2.25,0,0,0,0,0,0h0c.03.12.14.21.27.19.12-.02.21-.14.19-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.05,44.23h0c.12-.03.2-.15.18-.28h0c-.02-.12-.14-.2-.26-.18,0,0,0,0-.01,0-.13.02-.21.14-.19.26,0,0,0,0,0,.01.02.12.14.2.26.18,0,0,0,0,.01,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.28,45.08c.12-.03.19-.16.16-.28-.04-.12-.16-.19-.29-.16-.12.03-.2.16-.17.28,0,0,0,0,0,.01h0c.03.12.16.19.28.16,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.69,45.63h0c-.04-.12-.17-.18-.29-.14,0,0,0,0,0,0h0c-.12.03-.19.16-.15.27,0,0,0,0,0,.01h0c.04.12.17.19.3.15,0,0,0,0,0,0h0c.12-.04.18-.17.14-.29,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M46.32,47.26h0c-.05-.12-.18-.17-.3-.12-.12.05-.17.19-.12.31,0,0,0,0,0,0,.05.11.18.17.29.12,0,0,0,0,0,0h0c.12-.05.17-.19.12-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M46.71,48.04h0c-.05-.11-.19-.15-.3-.1,0,0-.01,0-.02,0-.11.06-.16.2-.1.31.06.11.2.15.31.09,0,0,0,0,0,0h0c.11-.06.16-.2.1-.31,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M47.14,48.8h0c-.07-.11-.21-.15-.32-.08-.11.07-.15.21-.08.32.07.11.21.15.32.08h0c.11-.06.15-.2.08-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M47.61,49.54h0c-.07-.1-.21-.13-.32-.06h0c-.11.07-.14.21-.08.32,0,0,0,0,0,.01.08.1.22.13.33.06h0c.1-.06.14-.2.07-.31,0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M47.77,50.21c-.1.08-.13.22-.06.33h0c.07.1.22.13.32.05,0,0,0,0,0,0h0c.09-.09.09-.24,0-.33-.07-.07-.18-.09-.27-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M48.63,50.95h0c-.08-.1-.23-.11-.32-.03h0c-.1.08-.12.22-.05.32,0,0,0,0,0,.01.07.1.21.12.31.04,0,0,0,0,.01-.01h0c.1-.08.12-.22.04-.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M49.19,51.62h0c-.1-.08-.24-.07-.32.02-.1.08-.11.23-.03.33h0c.09.09.24.08.32-.01,0,0,0,0,0,0h0c.08-.09.08-.24-.02-.32h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M49.78,52.27h0c-.09-.09-.23-.1-.33,0-.09.09-.1.23,0,.33.09.09.24.08.32-.01,0,0,0,0,0,0h0c.08-.09.08-.24-.02-.32l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M50.07,52.89c-.09.09-.08.24.01.32,0,0,0,0,0,0h0c.09.09.24.08.32-.01,0,0,0,0,0,0,.09-.09.09-.24,0-.33s-.24-.09-.33,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M51.04,53.48c-.1-.08-.24-.07-.33.02-.07.11-.04.26.07.33.08.05.19.05.27-.01h0c.08-.1.07-.24-.02-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M51.38,54.09h0c-.08.09-.08.24.02.32h0c.09.09.24.08.32-.01,0,0,0,0,0,0h0c.08-.1.06-.24-.04-.32s-.24-.06-.32.04h0v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M52.4,54.59c-.1-.08-.24-.07-.33.02-.09.09-.08.24.01.32,0,0,0,0,0,0h0c.09.09.24.08.32-.01,0,0,0,0,0,0h0c.08-.1.08-.24-.02-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M52.77,55.18c-.07.1-.05.25.06.32s.25.05.32-.06h0c.07-.1.05-.25-.06-.32s-.25-.05-.32.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M53.49,55.69h0c-.07.11-.04.25.06.32,0,0,0,0,0,0,.1.07.24.05.31-.05,0,0,0,0,0-.01h0c.07-.1.05-.25-.06-.32,0,0,0,0,0,0-.1-.07-.25-.05-.32.06,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M54.24,56.16c-.07.11-.04.26.07.33,0,0,0,0,0,0h0c.11.07.25.03.32-.08,0,0,0,0,0,0h0c.07-.11.04-.25-.07-.32,0,0,0,0,0,0-.11-.06-.25-.03-.32.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M55.31,56.54c-.11-.06-.25-.02-.32.09-.06.11-.03.24.07.31h0c.11.05.25.01.31-.1h0c.06-.1.03-.23-.07-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M56.08,56.96c-.12-.06-.26-.01-.32.1h0c-.06.11-.01.25.1.31,0,0,0,0,0,0h0c.11.06.24.02.3-.08,0,0,0,0,0-.01h0c.06-.11.02-.26-.1-.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "57.22 58.02 57.22 58.02 57.23 58.02 57.23 58.02 57.21 58.02 57.22 58.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M62.02,70.24h0c-.14-.22-.42-.29-.64-.17h0c-.22.13-.29.42-.17.64.13.23.42.31.66.18,0,0,0,0,0,0,.22-.14.3-.43.16-.65,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M63.52,69.24c-.15-.21-.44-.26-.66-.12h0c-.21.15-.26.44-.12.66.14.22.43.28.64.14,0,0,0,0,.01,0,.22-.15.27-.45.12-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M64.28,68.07h0c-.2.17-.23.46-.08.67.16.21.46.25.66.09,0,0,0,0,0,0h0c.19-.19.19-.49,0-.68-.16-.16-.41-.19-.6-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M65.65,66.92h0c-.19.17-.2.47-.03.66h0c.16.2.46.22.66.06,0,0,0,0,.01-.01.2-.17.22-.47.05-.67,0,0,0,0,0,0-.18-.19-.48-.2-.68-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M66.92,65.7c-.18.18-.18.48,0,.66,0,0,0,0,0,0,.18.19.48.19.67.01h0c.18-.19.17-.49-.02-.67h0c-.18-.18-.47-.19-.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M68.11,64.39h0c-.16.21-.12.5.08.67h0c.2.16.5.13.66-.08,0,0,0,0,0,0h0c.16-.2.13-.5-.08-.66,0,0,0,0,0,0-.21-.16-.51-.12-.67.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M70.89,61.42h0c-.23-.12-.52-.03-.64.2-.1.2-.05.44.12.58.22.14.51.09.66-.13h0c.13-.22.07-.51-.15-.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M71.15,60.04h0c-.12.23-.04.52.19.65h0c.22.13.51.05.64-.17,0,0,0,0,0-.01h0c.1-.25-.02-.53-.26-.63-.2-.08-.44-.02-.57.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M72.6,58.25h0c-.24-.11-.51-.01-.64.22h0c-.11.23-.01.51.22.62,0,0,0,0,0,0h0c.23.12.51.03.63-.2,0,0,0-.01,0-.02.11-.23.02-.5-.21-.62,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M73.29,56.58c-.24-.1-.52.02-.62.26s.02.52.26.62h0c.24.1.52,0,.62-.25,0,0,0,0,0,0h0c.09-.25-.03-.52-.27-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M73.89,54.89c-.25-.08-.51.05-.6.3h0c-.08.25.06.51.31.6h0c.24.09.5-.03.59-.27,0,0,0-.02,0-.03h0c.08-.24-.05-.51-.29-.59,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M74.36,53.15c-.25-.06-.5.09-.57.33h0c-.06.25.08.5.33.57h0c.25.07.52-.08.59-.33.07-.24-.08-.5-.32-.56,0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M74.73,51.38c-.26-.04-.5.13-.55.38h0c-.05.25.12.5.37.55h0c.26.06.51-.1.56-.36,0,0,0,0,0-.01.04-.26-.13-.51-.39-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M74.98,49.61c-.26-.03-.49.15-.53.4h0c-.03.26.15.49.41.53h0c.26.03.5-.15.53-.41h0c.03-.26-.15-.49-.41-.52,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M75.11,47.8h0c-.26,0-.47.19-.49.44h0c-.02.26.18.48.44.5.26.02.49-.18.52-.45.01-.26-.19-.48-.45-.5,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M75.12,45.98h0c-.26,0-.46.21-.46.47h0c0,.26.21.46.47.47h0c.26,0,.48-.2.48-.46,0,0,0-.01,0-.02-.01-.26-.23-.47-.49-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M75.03,44.2c-.26.02-.46.25-.44.51h0c.02.26.25.45.51.44h0c.26-.01.46-.23.44-.49,0,0,0-.01,0-.02h0c-.01-.26-.23-.46-.49-.44,0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M74.48,40.64c-.25.05-.41.3-.37.55h0c.05.25.3.42.56.36h0c.26-.03.45-.27.41-.53-.03-.26-.27-.45-.53-.41-.03,0-.06,0-.08.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M74.03,38.89h0c-.25.07-.4.33-.33.58h0c.07.25.33.4.58.33h0c.25-.06.4-.32.34-.57,0,0,0-.01,0-.02h0c-.07-.25-.32-.4-.57-.33,0,0,0,0-.01,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M73.17,37.78h0c.08.24.35.37.59.29h0c.25-.08.39-.35.31-.6-.08-.25-.35-.38-.6-.3,0,0,0,0-.01,0-.24.1-.36.36-.29.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M72.54,36.12c.1.24.38.35.62.26h0c.24-.1.36-.37.27-.61,0,0,0,0,0-.01h0c-.11-.24-.39-.35-.63-.25-.24.1-.35.38-.25.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M71.8,34.52c.12.23.41.33.64.21h0c.23-.11.33-.39.22-.62,0,0,0,0,0-.01h0c-.14-.23-.43-.3-.66-.16-.2.12-.28.37-.2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M70.95,32.96h0c.14.22.42.29.65.17h0c.23-.12.31-.41.19-.63,0,0,0,0,0-.01h0c-.12-.23-.41-.31-.63-.18,0,0-.01,0-.02,0-.22.14-.3.42-.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M70.02,31.44c.14.22.43.28.65.14h0c.22-.14.28-.44.14-.66h0c-.17-.2-.47-.23-.68-.06-.17.15-.22.39-.12.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M68.98,30.02h0c.16.2.45.24.66.08h0c.21-.15.26-.44.1-.65,0,0,0-.01-.01-.02-.18-.19-.49-.2-.68-.01-.16.15-.19.4-.08.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M68.53,28.69h0c.2-.17.22-.47.05-.67h0c-.18-.2-.48-.21-.68-.04-.19.18-.21.47-.04.67.18.19.47.21.67.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M66.65,27.35h0c.22.14.51.07.65-.15.1-.16.1-.37-.01-.52-.17-.18-.46-.19-.65-.02,0,0-.02.02-.02.02-.18.18-.18.48,0,.67h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M63.98,25.02h0c.21.16.51.12.67-.08h0c.16-.2.13-.5-.08-.66,0,0,0,0,0,0-.2-.16-.5-.13-.66.08,0,0,0,0,0,0-.16.21-.12.5.08.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M62.55,24h0c.22.14.51.08.66-.13h0c.15-.22.09-.51-.13-.66-.21-.15-.5-.09-.65.12,0,0,0,.01-.01.02h0c-.14.22-.08.5.13.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M61.04,23.05h0c.23.12.51.04.64-.17h0c.19-.18.19-.48,0-.67s-.48-.19-.67,0c-.06.05-.1.12-.12.2h0c-.12.23-.05.51.17.64h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M59.48,22.22h0c.23.11.52.02.63-.22h0c.12-.23.03-.51-.19-.63,0,0-.01,0-.02,0-.24-.12-.52-.02-.64.22-.12.24-.02.52.22.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M57.86,21.49h0c.24.1.51-.01.62-.25h0c.1-.24,0-.53-.25-.63-.24-.1-.52.01-.62.25,0,0,0,0,0,.01-.09.24.02.51.26.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M56.2,20.87h0c.24.07.51-.06.59-.3h0c.08-.25-.05-.52-.3-.6-.25-.08-.52.05-.6.3-.08.24.05.51.29.59h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M54.49,20.35h0c.25.06.51-.09.58-.34h0c.07-.25-.08-.52-.33-.59h0c-.25-.07-.51.07-.57.32,0,0,0,.01,0,.02-.06.25.08.51.33.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M52.79,19.94c.25.05.5-.11.55-.36,0,0,0,0,0,0,.06-.25-.1-.51-.35-.57,0,0,0,0,0,0h0c-.26-.05-.51.11-.56.37,0,0,0,0,0,.01-.05.25.11.5.36.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M51.04,19.65c.26.02.49-.16.53-.41h0c.04-.25-.13-.49-.38-.53,0,0,0,0-.01,0h0c-.26-.03-.49.16-.52.41-.03.25.13.48.38.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M47.51,19.39c.26,0,.47-.2.47-.46,0,0,0,0,0,0h0c0-.26-.2-.48-.47-.49h0c-.26,0-.47.22-.47.48,0,0,0,0,0,0h0c0,.26.2.47.46.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M45.71,19.45c.26-.02.45-.24.44-.5h0c0-.25-.22-.45-.47-.45,0,0-.02,0-.02,0h0c-.26.06-.42.31-.37.57.04.2.21.35.42.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M43.98,19.61h0c.26-.04.44-.27.41-.53h0c-.03-.26-.27-.44-.53-.41h0c-.25.02-.44.25-.42.5,0,0,0,.02,0,.03.04.26.27.44.53.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M42.23,19.88c.25-.04.42-.28.38-.53,0,0,0-.01,0-.02h0c-.04-.26-.29-.43-.55-.39,0,0,0,0,0,0h0c-.25.06-.42.31-.36.57h0c.05.25.29.41.53.37,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M40.5,20.28c.25-.07.4-.33.34-.58h0c-.06-.25-.31-.4-.56-.34,0,0,0,0,0,0h0c-.25.07-.39.33-.33.58.07.24.31.39.56.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M38.81,20.79h0c.25-.1.36-.38.26-.63-.09-.22-.34-.35-.57-.28h0c-.25.08-.38.35-.29.6.09.25.35.38.6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M37.14,21.4h0c.24-.1.36-.37.26-.61h0c-.1-.25-.38-.37-.63-.28-.24.11-.35.38-.25.62.1.23.37.35.61.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M35.52,22.12h0c.23-.12.32-.4.22-.63h0c-.11-.24-.39-.34-.63-.23,0,0,0,0,0,0-.24.12-.33.4-.22.64.11.23.4.33.63.22,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M33.8,23.87h0c.25.06.51-.08.58-.33h0c.07-.26-.08-.52-.34-.59-.25-.07-.51.08-.58.33h0c-.07.26.08.52.34.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M33.33,25.61h0c.26.06.52-.09.59-.35h0c.07-.24-.07-.49-.31-.56-.01,0-.02,0-.03,0-.26-.06-.52.09-.59.35h0c-.06.25.08.5.33.56,0,0,.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M32.97,27.39c.26.05.51-.12.56-.37h0c.04-.26-.12-.51-.38-.56h0c-.25-.05-.5.11-.55.36,0,0,0,0,0,.01h0c-.05.26.11.51.37.56,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M33.21,28.77h0c.05-.25-.12-.5-.37-.54,0,0,0,0-.01,0-.26-.04-.51.13-.56.39-.04.26.13.5.39.54,0,0,0,0,0,0h0c.26.03.5-.14.54-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M32.45,30.95h0c.26.03.49-.15.53-.41h0c.03-.26-.15-.49-.41-.53,0,0,0,0,0,0h0c-.26-.04-.5.14-.54.4s.14.5.4.54c0,0,.02,0,.03,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M32.3,32.75h0c.25.02.47-.17.5-.42,0,0,0,0,0-.01h0c0-.26-.18-.48-.44-.51-.25-.03-.47.14-.51.39,0,.02,0,.03,0,.05,0,.26.19.48.45.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M32.21,34.55h0c.26,0,.48-.2.5-.46h0c.01-.26-.19-.47-.45-.48,0,0,0,0-.01,0h0c-.26-.01-.49.19-.5.46h0c-.01.26.19.47.45.48,0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M32.23,36.36h0c.26,0,.46-.22.46-.48h0c-.01-.26-.23-.46-.49-.46-.25,0-.46.2-.46.46,0,0,0,.01,0,.02,0,.26.23.47.49.46,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M32.32,38.16h0c.25-.01.44-.23.42-.48,0,0,0-.01,0-.02h0c-.01-.26-.23-.46-.49-.44,0,0,0,0,0,0h0c-.26.02-.47.24-.46.5.02.26.25.46.52.44,0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M32.51,39.96c.26-.04.45-.27.43-.53h0c-.03-.26-.26-.44-.52-.41h0c-.26.03-.45.26-.42.52,0,0,0,0,0,0h0c.02.26.25.44.51.42,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M32.8,41.73h0c.25-.05.42-.29.38-.55h0c-.05-.26-.3-.43-.56-.39h0c-.25.04-.42.28-.38.54,0,0,0,0,0,0,.05.26.3.43.56.39,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M33.52,42.94c-.05-.25-.3-.41-.55-.36,0,0,0,0,0,0-.26.05-.42.3-.38.56h0c.07.25.33.4.58.35.25-.06.4-.3.35-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M33.64,45.24h0c.25-.08.4-.34.34-.59h0c-.07-.25-.33-.4-.58-.33-.25.07-.4.33-.34.59.07.25.32.4.57.33,0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M34.23,46.95c.25-.08.38-.35.29-.6-.09-.24-.36-.37-.61-.29-.25.08-.38.35-.3.6,0,0,0,0,0,0h0c.08.24.35.37.59.29,0,0,.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M35.15,48.04h0c-.11-.24-.39-.35-.63-.25h0c-.23.09-.35.35-.26.58,0,.01,0,.02.01.03h0c.1.24.39.36.63.25,0,0,0,0,0,0h0c.24-.1.35-.38.25-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M36.68,51.21h0c-.13-.23-.41-.31-.64-.19-.23.13-.31.41-.19.64.12.23.39.31.62.2,0,0,.01,0,.02-.01h0c.23-.13.31-.41.19-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M37.56,52.75h0c-.14-.22-.43-.29-.65-.15,0,0,0,0,0,0-.22.14-.29.43-.15.65.14.22.43.29.65.15h0c.22-.14.29-.43.16-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M38.55,54.24h0c-.15-.21-.45-.26-.66-.11-.21.14-.27.43-.13.65,0,0,0,0,0,.01.15.21.45.26.66.11h0c.21-.15.27-.44.12-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M39.6,55.69h0c-.16-.2-.45-.23-.66-.08h0c-.21.15-.26.44-.1.65,0,0,0,.01.01.02.17.21.46.24.67.08h0c.2-.16.24-.45.08-.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M40.05,57.01c-.2.17-.23.46-.08.67h0c.18.19.48.21.68.04h0c.2-.17.23-.47.06-.67s-.47-.23-.67-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M41.87,58.41h0c-.17-.19-.47-.2-.66-.03,0,0,0,0,0,0h0c-.19.18-.21.48-.03.68.17.19.46.21.65.04,0,0,.01-.01.02-.02h0c.19-.18.2-.47.03-.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M43.14,59.68h0c-.15-.21-.44-.27-.66-.12-.21.15-.27.44-.12.66.04.05.08.1.14.13h0c.18.18.47.19.65.01,0,0,.01-.01.02-.02h0c.18-.19.19-.48,0-.67h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M44.44,60.91h0c-.19-.18-.49-.16-.67.03-.18.19-.16.49.03.67.19.18.49.16.67-.03,0,0,0,0,0,0h0c.18-.19.17-.49-.03-.67,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M45.11,62.14c-.16.2-.13.5.08.66,0,0,0,0,0,0h0c.2.16.48.13.65-.06,0,0,.01-.01.02-.02.17-.2.15-.51-.05-.68-.2-.17-.51-.15-.68.05h0l-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M47.17,63.17c-.21-.16-.5-.12-.67.08-.16.2-.13.5.08.66,0,0,0,0,0,0,.2.16.5.13.66-.08,0,0,0,0,0,0h0c.16-.21.12-.5-.08-.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M47.95,64.38h0c-.16.2-.13.5.08.66,0,0,0,0,0,0h0c.21.16.5.12.66-.08h0c.15-.22.1-.52-.12-.67s-.52-.1-.67.12l.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M50.08,65.28c-.22-.14-.51-.08-.65.14,0,0,0,0,0,0-.15.21-.09.5.12.65,0,0,0,0,.01,0h0c.21.14.5.09.65-.13,0,0,0,0,0-.01h0c.15-.21.09-.5-.12-.65,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M50.94,66.4c-.09.24.03.52.28.61.18.07.38.02.51-.11.14-.22.07-.51-.16-.65,0,0,0,0,0,0-.22-.12-.49-.05-.62.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M52.48,67.33h0c-.13.23-.05.52.18.65,0,0,0,0,0,0,.23.13.52.05.65-.18h0c.13-.23.04-.52-.18-.65-.23-.13-.52-.04-.65.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M54.06,68.2c-.12.23-.04.52.2.65h0c.23.12.52.03.64-.2,0,0,0,0,0,0h0c.12-.23.03-.52-.2-.65-.23-.12-.52-.03-.64.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M56.3,68.8c-.23-.11-.51-.02-.62.21,0,0,0,0,0,.01-.11.22-.03.5.19.62h0c.23.1.5,0,.61-.23h0c.11-.22.04-.48-.17-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M57.92,69.55c-.24-.1-.52,0-.62.24h0c-.11.24,0,.52.23.63,0,0,0,0,0,0h0c.23.11.51,0,.62-.23,0,0,0,0,0,0h0c.11-.23.01-.51-.22-.62,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "34.41 22.15 34.41 22.14 34.41 22.15 34.41 22.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "60.39 71.54 60.41 71.55 60.42 71.55 60.42 71.55 60.39 71.54 60.39 71.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "29.56 78.72 40.44 75.42 40.51 75.62 29.64 78.93 29.56 78.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "28.77 75.47 39.04 72.15 39.13 72.35 28.85 75.68 28.77 75.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "28.44 72.51 37.27 69.6 37.34 69.81 28.52 72.72 28.44 72.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "28.64 70.15 35.46 67.73 35.54 67.93 28.72 70.36 28.64 70.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "28.98 67.96 33.68 66.15 33.76 66.35 29.06 68.16 28.98 67.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "31.87 64.87 31.92 65.09 29.45 65.88 29.41 65.66 31.87 64.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "31.39 60.81 31.48 61.02 27.19 63.35 27.11 63.15 31.39 60.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "31.49 58.31 31.57 58.52 25.39 61.67 25.31 61.47 31.49 58.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "31.09 55.31 31.18 55.52 23.59 59.54 23.5 59.34 31.09 55.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "30.1 51.98 30.18 52.18 21.86 56.76 21.77 56.55 30.1 51.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "28.7 48.72 28.78 48.92 20.46 53.49 20.37 53.29 28.7 48.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "26.97 45.93 27.05 46.14 19.47 50.16 19.38 49.95 26.97 45.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "25.2 43.78 25.29 43.99 19.01 47.01 18.92 46.81 25.2 43.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "23.37 42.12 23.45 42.33 19 44.6 18.92 44.39 23.37 42.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.38 40.88 21.46 41.08 19.22 42.16 19.13 41.95 21.38 40.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "16.8 39.12 21.49 37.31 21.58 37.52 16.88 39.33 16.8 39.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "15.02 37.54 21.83 35.11 21.91 35.32 15.09 37.74 15.02 37.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "13.21 35.66 22.1 32.73 22.18 32.93 13.29 35.87 13.21 35.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "11.43 33.12 21.71 29.79 21.79 30 11.51 33.33 11.43 33.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "10.04 29.85 20.92 26.54 20.99 26.75 10.12 30.06 10.04 29.85"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-61",
    cx: 40.44,
    cy: 75.41,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 39.08,
    cy: 72.22,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-68",
    cx: 28.5,
    cy: 72.66,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 37.31,
    cy: 69.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 35.45,
    cy: 67.71,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 28.64,
    cy: 70.15,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 33.8,
    cy: 66.19,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 28.98,
    cy: 67.96,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 31.75,
    cy: 64.94,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 29.34,
    cy: 65.82,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-69",
    cx: 29.88,
    cy: 63.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 31.34,
    cy: 60.92,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 31.51,
    cy: 58.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 31.09,
    cy: 55.31,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 30.14,
    cy: 52.07,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-60",
    cx: 28.82,
    cy: 48.76,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 19.43,
    cy: 50.09,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 27.03,
    cy: 46.07,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 19.09,
    cy: 46.86,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 25.3,
    cy: 43.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 23.3,
    cy: 42.24,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 18.98,
    cy: 44.43,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 19.06,
    cy: 42.04,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 21.53,
    cy: 40.82,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-62",
    cx: 21.54,
    cy: 37.53,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 21.85,
    cy: 35.17,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 15.17,
    cy: 37.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-63",
    cx: 13.26,
    cy: 35.79,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 22.14,
    cy: 32.82,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 21.94,
    cy: 29.94,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 11.48,
    cy: 33.25,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 21.38,
    cy: 26.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 9.68,
    cy: 30.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 16.91,
    cy: 39.23,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 19.65,
    cy: 39.92,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 20.54,
    cy: 53.46,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 21.8,
    cy: 56.62,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 23.58,
    cy: 59.54,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 27.12,
    cy: 63.28,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 25.36,
    cy: 61.61,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.83,
    cy: 75.64,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 29.69,
    cy: 78.83,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M53.3,41.61c2.36-1.27,3.24-4.22,1.97-6.58s-4.22-3.24-6.58-1.97c-2.36,1.27-3.24,4.21-1.97,6.57,1.27,2.36,4.21,3.25,6.57,1.98,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M62.17,45.26c-1.27-2.36-4.22-3.25-6.58-1.98-2.36,1.27-3.25,4.22-1.98,6.58,1.27,2.36,4.22,3.25,6.58,1.98,0,0,0,0,0,0,2.36-1.27,3.24-4.22,1.97-6.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M50.17,51.66c2.35-1.31,3.19-4.28,1.88-6.63-1.31-2.35-4.28-3.19-6.63-1.88h0c-.19.1-.37.22-.55.35.79,3.23,2.65,6.1,5.29,8.13v.03Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic2);
export default __webpack_public_path__ + "static/media/topic_2.57b4493c7b08eda7e90b1b4691b76439.svg";
export { ForwardRef as ReactComponent };